import { useState, useMemo } from 'react';
import { useFuse } from '../components/useFuse';
import CloseIcon from '@mui/icons-material/Close';

export default function AccountMultiSelect({ accounts, selected, onChange, placeholder }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [inputActive, setInputActive] = useState(false);
  const [mouseOverResult, setMouseOverResult] = useState(false);

  const list = useMemo(
    () => (accounts || []).map((account) => ({ id: account.id, label: account.name })),
    [accounts]
  );

  const selectedIds = useMemo(
    () => new Set(selected.map((s) => s.id)),
    [selected]
  );

  const available = useMemo(
    () => list.filter((account) => !selectedIds.has(account.id)),
    [list, selectedIds]
  );

  const searchResults = useFuse(searchTerm, available);

  const handleSelect = (option) => {
    onChange([...selected, { id: option.id, name: option.label }]);
    setSearchTerm('');
    setInputActive(true);
  };

  const handleRemove = (id) => {
    onChange(selected.filter((account) => account.id !== id));
  };

  const exactMatch = (query, text) => {
    const regex = new RegExp(`^${query}`, 'i');
    return regex.test(text);
  };

  return (
    <div className="ww-account-multi-select">
      {selected.length > 0 && (
        <div className="ww-account-chips">
          {selected.map((account) => (
            <span key={account.id} className="ww-account-chip">
              {account.name}
              <button type="button" onClick={() => handleRemove(account.id)} aria-label={`Remove ${account.name}`}>
                <CloseIcon />
              </button>
            </span>
          ))}
        </div>
      )}

      <div className={`ww-account-search ${inputActive ? 'active' : ''}`}>
        <input
          className="ww-price-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={placeholder || 'Search accounts'}
          onFocus={() => setInputActive(true)}
          onBlur={() => (mouseOverResult ? null : setInputActive(false))}
        />
        <div className={`ww-account-results ${inputActive && searchTerm ? 'shown' : ''}`}>
          {searchResults.slice(0, 10).map((result) => (
            <button
              key={result.id}
              type="button"
              className={`ww-account-result ${exactMatch(searchTerm, result.label) ? 'exact-match' : ''}`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelect(result)}
              onMouseOver={() => setMouseOverResult(true)}
              onMouseLeave={() => setMouseOverResult(false)}
            >
              {result.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
